import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { sellersReportApi } from '../../../features/sales/sellersReportSlice'
import SellersReportTable from './components/SellersReportTable'
import dayjs from 'dayjs'
import DatePicker from '../../../components/muiComponents/datePicker/DatePicker'
import Sentinel from '../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../app/hooks/usePaginatedList'

const SellersReportPage = () => {
    const { formatMessage } = useIntl()
    const [startDate, setStartDate] = React.useState<Date | null>(dayjs().startOf('month').toDate())
    const [endDate, setEndDate] = React.useState<Date | null>(dayjs().endOf('month').toDate())
    const [filter, setFilter] = useState('')
    const [fetchSellersReport] = sellersReportApi.useLazyFetchSellersReportQuery()

    const { rows, isLoading, loadedPages, sentinelRef } = usePaginatedList(
        (page, size) =>
            fetchSellersReport({
                startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
                endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
                filter,
                size,
                page,
            }).unwrap(),
        [startDate, endDate, filter],
    )
    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'sellersReport' })}</H3>
                    </Title>
                </Header>

                <DateWrapper>
                    <DatePicker
                        label={formatMessage({ id: 'startDate' })}
                        value={startDate}
                        handleChange={(event) => setStartDate(event)}
                    />
                    <DatePicker
                        label={formatMessage({ id: 'endDate' })}
                        value={endDate}
                        handleChange={(event) => setEndDate(event)}
                    />
                </DateWrapper>

                {isLoading && loadedPages === 0 ? (
                    <LinearProgress />
                ) : (
                    <>
                        <SellersReportTable
                            sellersData={rows}
                            isFetchingSellers={isLoading}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default SellersReportPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const DateWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    margin-top: 20px;
`